import { useQuery, useQueryClient } from 'react-query'

import { VistaProdutoService } from '../services/vista-produto.service'
import { VistaService } from '../services/vista.service'

export const VistaProductHooks = {
  getByVistaId: (vistaId: string) => {
    const queryClient = useQueryClient()
    const queryKey = ['VistaProductHooks.getByVistaId', { vistaId }]

    const query = useQuery(queryKey, async () => {
      const vista = await VistaService.findById({ vistaId })
      const products = await VistaProdutoService.findByVistaId({
        vistaId,
      })

      products.sort((a, b) => (a.vistaIndex > b.vistaIndex ? 1 : -1))

      return { vista, products }
    })

    const invalidate = () => queryClient.invalidateQueries(queryKey)

    return { query, invalidate }
  },
}
